import { render } from "./stats.vue?vue&type=template&id=597a3233&scoped=true"
import script from "./stats.vue?vue&type=script&lang=js"
export * from "./stats.vue?vue&type=script&lang=js"

import "./stats.vue?vue&type=style&index=0&id=597a3233&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-accounting-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-597a3233"]])

export default __exports__